import { AssetPreviewPdfController } from './asset-preview-pdf.controller'

function assetPreviewPdf () {
  return {
    restrict: 'E',
    scope: {
      template: '=',
      previewFlags: '=',
      location: '<',
      contextData: '<'
    },
    templateUrl: '/core/directives/asset-preview-pdf/asset-preview-pdf.html?$$REVISION$$',
    controller: AssetPreviewPdfController
  }
}
export { assetPreviewPdf }
